(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["psl-footer-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('psl-footer-localization')) {
    customElements.define('psl-footer-localization', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.dialogs = Array.from(this.querySelectorAll('dialog'));
        if (!this.dialogs.length && document.readyState === 'loading') {
          if (!this.waitingForContent) {
            this.waitingForContent = true;
            document.addEventListener('DOMContentLoaded', () => { if (this.isConnected) this.connectedCallback(); }, { once: true });
          }
          return;
        }
        if (!this.dialogs.length || typeof this.dialogs[0].showModal !== 'function') return;
        this.initialized = true;
        this.querySelector('[data-picker-controls]').hidden = false;
        this.querySelector('[data-picker-fallback]').hidden = true;
        this.querySelectorAll('[data-picker-open]').forEach((trigger) => {
          trigger.addEventListener('click', () => {
            const dialog = this.dialogs.find((item) => item.id === trigger.dataset.pickerOpen);
            if (!dialog || dialog.open) return;
            this.opener = trigger;
            const countrySearch = dialog.querySelector('[data-country-search]');
            if (countrySearch) { countrySearch.value = ''; countrySearch.dispatchEvent(new Event('input')); }
            dialog.showModal();
            trigger.setAttribute('aria-expanded', 'true');
            document.documentElement.classList.add('psl-footer-picker-open');
            const focusTarget = dialog.querySelector('[data-country-search]') || dialog.querySelector('[aria-current="true"]') || dialog.querySelector('button[type="submit"]');
            if (focusTarget) focusTarget.focus();
          });
        });
        this.dialogs.forEach((dialog) => {
          dialog.querySelector('[data-picker-close]').addEventListener('click', () => dialog.close());
          dialog.addEventListener('click', (event) => {
            if (event.target !== dialog) return;
            const bounds = dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
          });
          dialog.addEventListener('close', () => {
            if (!document.querySelector('.psl-footer-picker[open]')) document.documentElement.classList.remove('psl-footer-picker-open');
            if (this.opener) {
              this.opener.setAttribute('aria-expanded', 'false');
              if (this.opener.isConnected) this.opener.focus();
            }
          });
          dialog.querySelector('form').addEventListener('submit', (event) => {
            const returnTo = event.target.querySelector('input[name="return_to"]');
            if (!returnTo) return;
            const destination = new URL(window.location.href);
            if (dialog.dataset.pickerKind === 'country') destination.searchParams.delete('country');
            returnTo.value = destination.pathname + destination.search + destination.hash;
          });
        });
        const search = this.querySelector('[data-country-search]');
        if (search) {
          const rows = Array.from(this.querySelectorAll('[data-country-option]'));
          const empty = this.querySelector('[data-no-countries]');
          const normalize = (text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
          const regionNames = typeof Intl.DisplayNames === 'function' ? ['en', 'de', 'fr'].map((locale) => new Intl.DisplayNames([locale], { type: 'region' })) : [];
          rows.forEach((row) => { row.searchText = normalize([row.dataset.countrySearchText, ...regionNames.map((names) => names.of(row.dataset.countryCode))].join(' ')); });
          const visibleButtons = () => rows.filter((row) => !row.hidden).map((row) => row.querySelector('button'));
          search.addEventListener('input', () => {
            const query = normalize(search.value);
            rows.forEach((row) => { row.hidden = !row.searchText.includes(query); });
            empty.hidden = visibleButtons().length > 0;
          });
          search.addEventListener('keydown', (event) => {
            const options = visibleButtons();
            if (event.key === 'Enter') {
              event.preventDefault();
              if (options.length === 1) options[0].click();
            }
            if (event.key === 'ArrowDown' && options.length) { event.preventDefault(); options[0].focus(); }
          });
        }
        this.dialogs.forEach((dialog) => {
          dialog.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') { event.preventDefault(); dialog.close(); return; }
            if (!['ArrowDown', 'ArrowUp'].includes(event.key) || event.target.matches('input')) return;
            const options = Array.from(dialog.querySelectorAll('li:not([hidden]) button[type="submit"]'));
            if (!options.length) return;
            const current = options.indexOf(document.activeElement);
            const next = event.key === 'ArrowDown' ? (current + 1) % options.length : (current < 0 ? options.length - 1 : (current - 1 + options.length) % options.length);
            event.preventDefault();
            options[next].focus();
          });
        });
      }
      disconnectedCallback() {
        if (this.dialogs) this.dialogs.filter((dialog) => dialog.open).forEach((dialog) => dialog.close());
        if (!document.querySelector('.psl-footer-picker[open]')) document.documentElement.classList.remove('psl-footer-picker-open');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["psl-order-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('psl-order-controls')) {
    const helmetRanges={"6687307497574":{"Medium":"55–58","Large":"58–61"},"6748954722406":{"Medium":"52–58","Large":"58–62"},"6850216329318":{"Medium":"52–58","Large":"58–62"},"6850217443430":{"Medium":"52–58","Large":"58–62"},"6850217607270":{"Medium":"52–58","Large":"58–62"},"8337371332947":{"Medium":"52–58","Large":"58–62"},"8337376280915":{"Medium":"52–58","Large":"58–62"},"8337381753171":{"Medium":"52–58","Large":"58–62"},"8340635550035":{"Medium":"52–58","Large":"58–62"},"8340640727379":{"Medium":"52–58","Large":"58–62"},"8345247613267":{"Medium":"50–57","Large":"53–59"},"8345255805267":{"Medium":"50–57","Large":"53–59"},"8345259770195":{"Medium":"50–57","Large":"53–59"},"8345404440915":{"Medium":"50–57","Large":"53–59"},"8345404735827":{"Medium":"50–57","Large":"53–59"},"8345404866899":{"Medium":"50–57","Large":"53–59"},"8464051994963":{"Medium":"55–59","Large":"57–62"},"8545636122963":{"(single)":"58–61"},"8547792912723":{"Small":"51–54","Medium":"55–58","Large":"59–61","Extra Large":"61–63"},"8547808969043":{"Medium":"54–58","Large":"58–61"},"8547812507987":{"Medium":"55–58","Large":null},"8547814801747":{"Medium":"55–58","Large":"58–61"},"8556461916499":{"Medium":"49–55","Large":"53–60"},"9815023845715":{"Medium":"49–55","Large":"53–60"},"10477127893331":{"(single)":"55–58"},"10815783600467":{"Medium":"50–57","Large":"54–61"},"6689184677990":{"(single)":"54–61"},"6708472414310":{"Medium":"49–55","Large":"53–60"},"6708474839142":{"Medium":"49–55","Large":"53–60"},"6737403936870":{"Medium":"52–58","Large":"58–62"},"6745749717094":{"Medium":"52–58","Large":"58–62"},"6748956295270":{"Medium":"52–58","Large":"58–62"},"6748956885094":{"Medium":"52–58","Large":"58–62"},"6771684606054":{"Medium":"52–58","Large":"58–62"},"10281152643411":{"Medium":"49–55","Large":"53–60"},"10281205301587":{"Medium":"49–55","Large":"53–60"},"4998899859558":{"Small":"50–56","Medium":"53–60"},"4999055442022":{"Small":"50–56","Medium":"53–60"},"4999088439398":{"Small":"50–56","Medium":"53–60"},"6743710269542":{"(single)":"47–51"},"6743747657830":{"XS":"47–51","S":"51–55"},"6744594940006":{"(single)":"46–51"},"6744613617766":{"(single)":"46–51"},"6744617353318":{"(single)":"46–51"},"6744620990566":{"(single)":"46–51"},"6744639766630":{"(single)":"50–56"},"6766431600742":{"(single)":"48–54"},"8341554528595":{"Small":"48–54","Medium":"51–57"},"8341565342035":{"Small":"48–54","Medium":"51–57"},"8341567406419":{"Small":"48–54","Medium":"51–57"},"8341570421075":{"Small":"48–54","Medium":"51–57"},"8341572714835":{"Small":"48–54","Medium":"51–57"},"9804132221267":{"(single)":"52–56"},"9804157714771":{"Medium":"52–56","Large":"56–59"},"9808416506195":{"(single)":"52–56"},"9809905910099":{"(single)":"52–56"},"9918498767187":{"(single)":"46–51"},"9918524981587":{"(single)":"46–51"},"9968050372947":{"(single)":"44–48"},"10519221305683":{"Small":"48–54","Medium":"51–57"},"10519407984979":{"Small":"48–54","Medium":"51–57"}};
    customElements.define('psl-order-controls',class extends HTMLElement {
      async connectedCallback() {
        if(this.abort)return;
        this.sectionId=this.dataset.sectionId;
        this.form=document.getElementById('product-form-'+this.sectionId);
        this.mainButton=document.getElementById('ProductSubmitButton-'+this.sectionId);
        this.info=document.getElementById('ProductInfo-'+this.sectionId);
        this.bar=this.querySelector('.psl-order-bar');
        if(!this.form||!this.mainButton||!this.info||!this.bar)return;
        this.barButton=this.bar.querySelector('button');
        this.priceRoot=document.getElementById('price-'+this.sectionId);
        this.abort=new AbortController();
        this.confirmed=true;
        if(this.dataset.model){
          await customElements.whenDefined('variant-selects');
          if(!this.isConnected)return;
          this.setupPicker();
          this.showSingleSize();
        }
        this.variantUnsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{
          if(String(data.sectionId)!==String(this.sectionId))return;
          this.refreshNative();
          if(this.picker)this.refreshOptions();
          this.sync();
        });
        this.nativeObserver=new MutationObserver(()=>{this.refreshNative();this.sync();});
        this.nativeObserver.observe(this.info,{childList:true,subtree:true});
        this.onSubmit=(event)=>{
          if(!this.confirmed){event.preventDefault();event.stopImmediatePropagation();this.requestSize();}
        };
        this.form.addEventListener('submit',this.onSubmit,{capture:true,signal:this.abort.signal});
        this.barButton.addEventListener('click',()=>{
          if(!this.confirmed){this.requestSize();return;}
          if(this.mainButton.disabled||this.mainButton.getAttribute('aria-disabled')==='true')return;
          const quantity=this.form.elements.namedItem('quantity');
          if(quantity&&!quantity.checkValidity()){
            quantity.scrollIntoView({block:'center'});quantity.reportValidity();return;
          }
          this.mainButton.click();
        },{signal:this.abort.signal});
        this.form.addEventListener('change',()=>this.sync(),{signal:this.abort.signal});
        this.buttonObserver=new MutationObserver(()=>this.sync());
        this.buttonObserver.observe(this.mainButton,{attributes:true,childList:true,subtree:true,characterData:true});
        if(this.priceRoot){this.priceObserver=new MutationObserver(()=>this.sync());this.priceObserver.observe(this.priceRoot,{attributes:true,childList:true,subtree:true,characterData:true});}
        this.observer=new IntersectionObserver(entries=>{
          const entry=entries[0];this.bar.hidden=entry.isIntersecting||entry.boundingClientRect.bottom>=0;
        });
        this.observer.observe(this.mainButton);
        this.sync();
      }
      showSingleSize(){
        if(this.native||this.picker)return;
        const range=helmetRanges[this.dataset.productId]?.['(single)'];
        const template=this.querySelector('[data-single-size-template]');
        if(!range||!template)return;
        this.singleSize=template.content.firstElementChild.cloneNode(true);
        this.singleSize.querySelector('[data-range]').textContent=range;
        (this.info.querySelector('.psl-buy-block')||this.mainButton).before(this.singleSize);
      }
      refreshNative(){
        this.native=this.info.querySelector('variant-selects');
        if(this.picker)this.native?.classList.add('psl-native-options-hidden');
      }
      setupPicker(){
        this.native=this.info.querySelector('variant-selects');
        if(!this.native||this.native.querySelectorAll('fieldset,select').length!==1)return;
        const script=this.querySelector('[data-picker-variants]');
        const template=this.querySelector('[data-picker-template]');
        if(!script||!template)return;
        const variants=JSON.parse(script.textContent);
        if(!variants.length||variants.length>20)return;
        this.parseCombined=value=>{
          const m=value?.match(/^(Medium|Large|Médio|Medio|Mediano|Grande|M|L)\s+(Zwart|Wit|Beige|Bege|Black|White|Noir|Blanc|Schwarz|Weiß|Weiss|Musta|Valkoinen|Sort|Hvid|Preto|Branco|Negro|Blanco|Nero|Bianco|Svart|Vit|Czarny|Biały|Beżowy|Fekete|Fehér|Bézs)$/i);
          if(!m)return null;
          const colour=/^(zwart|black|noir|schwarz|musta|sort|preto|negro|nero|svart|czarny|fekete)$/i.test(m[2])?'black':/^(wit|white|blanc|weiß|weiss|valkoinen|hvid|branco|blanco|bianco|vit|biały|fehér)$/i.test(m[2])?'white':'beige';
          return {size:/^(medium|médio|medio|mediano|m)$/i.test(m[1])?'medium':'large',colour};
        };
        const verifiedChoiceMaps={
          '10815783600467':{
            '54808766873939':{size:'medium',colour:'black',optionValueId:'8835792994643'},
            '54808766906707':{size:'large',colour:'black',optionValueId:'8835793027411'},
            '54808766939475':{size:'medium',colour:'beige',optionValueId:'8835793060179'},
            '54808766972243':{size:'large',colour:'beige',optionValueId:'8835793092947'}
          },
          '8556461916499':{
            '47166947197267':{size:'medium',colour:'black',optionValueId:'6288233595219'},
            '47166947262803':{size:'large',colour:'black',optionValueId:'6287556772179'},
            '52487161446739':{size:'medium',colour:'white',optionValueId:'6698167075155'},
            '52487165641043':{size:'large',colour:'white',optionValueId:'6698180739411'}
          }
        };
        const verifiedChoices=verifiedChoiceMaps[this.dataset.productId];
        const combined=variants.map(v=>{
          const choice=verifiedChoices?verifiedChoices[String(v.id)]:this.parseCombined(v.options?.[0]);
          return choice?{variant:v,...choice}:null;
        });
        const hasColours=combined.every(Boolean);
        const legend=this.native.querySelector('legend,.form__label')?.textContent.trim()||'';
        const normalizeOptionLabel=value=>value?.split('·')[0].trim().replace(/:\s*$/,'').toLocaleLowerCase()||'';
        const translatedSizeLabel=normalizeOptionLabel(this.dataset.sizeLabel);
        const hasSizeLabel=(translatedSizeLabel&&normalizeOptionLabel(legend)===translatedSizeLabel)||/^(Maat|Grootte|Größe|Grösse|Size|Taille|Koko|Størrelse|Tamanho|Talla|Taglia|Storlek|Rozmiar|Velikost|Μέγεθος|Méret)$/i.test(legend);
        const sizeOnly=!hasColours&&hasSizeLabel&&variants.every(v=>v.options?.length===1&&/^(?:(?:XS|S|M|L|XL|Small|Medium|Large|Extra Large|Pequeno|Pequeño|Médio|Medio|Mediano|Grande|Extra grande)(?:\s*\([^)]*cm\))?|(?:XS|S)\s*=\s*\d{2}\s*[-–]\s*\d{2}\s*cm)$/i.test(v.options[0]));
        if(!hasColours&&!sizeOnly)return;
        const map=hasColours?combined:variants.map(v=>({variant:v,size:v.options[0],colour:null}));
        if(new Set(map.map(x=>x.size+'-'+x.colour)).size!==map.length)return;
        const nativeOptions=[...this.native.querySelectorAll('input[type=radio],select option')];
        if(map.some(item=>!nativeOptions.some(option=>{
          if((item.optionValueId&&String(option.dataset.optionValueId)===item.optionValueId)||option.value===item.variant.options[0])return true;
          const choice=hasColours?this.parseCombined(option.value):null;
          return choice?.size===item.size&&choice?.colour===item.colour;
        })))return;
        this.map=map;this.hasColours=hasColours;
        const chosen=map.find(x=>String(x.variant.id)===this.form.elements.namedItem('id').value)||map.find(x=>x.variant.available)||map[0];
        this.colour=chosen.colour;
        const linked=new URLSearchParams(location.search).get('variant');
        this.confirmed=linked===String(chosen.variant.id);
        this.size=this.confirmed?chosen.size:null;
        this.picker=template.content.firstElementChild.cloneNode(true);
        this.colourLabels=JSON.parse(this.querySelector('[data-colour-labels]').textContent);
        const ranges=helmetRanges[this.dataset.productId]||{};
        const sizeLabel=size=>{
          const display=size.replace(/^(extra large|extra grande|small|pequeno|pequeño|medium|médio|medio|mediano|large|grande|xl|xs|s|m|l)(?=$|[\s(=])/i,label=>({'extra large':'XL','extra grande':'XL',small:'S',pequeno:'S','pequeño':'S',medium:'M','médio':'M',medio:'M',mediano:'M',large:'L',grande:'L',xl:'XL',xs:'XS',s:'S',m:'M',l:'L'})[label.toLowerCase()]);
          const key=/^(medium|médio|medio|mediano|m)(?:$|[\s(])/i.test(size)?'Medium':/^(large|grande|l)(?:$|[\s(])/i.test(size)?'Large':/^(small|pequeno|pequeño|s)(?:$|[\s(])/i.test(size)?'Small':/^(extra large|extra grande|xl)(?:$|[\s(])/i.test(size)?'Extra Large':size;
          return ranges[key]&&!/cm/i.test(display)?display+' · '+ranges[key]+' cm':display;
        };
        if(hasColours){
          for(const colour of new Set(map.map(x=>x.colour)))this.addOption('colours',colour,this.colourLabels[colour]);
        }else{
          this.picker.querySelector('[data-colours]').remove();
          if(map.some(x=>!ranges[/^(medium|médio|medio|mediano|m)$/i.test(x.size)?'Medium':/^(large|grande|l)$/i.test(x.size)?'Large':x.size]))this.picker.querySelector('[data-sizes] legend').textContent=legend;
        }
        for(const size of new Set(map.map(x=>x.size)))this.addOption('sizes',size,sizeLabel(size));
        this.native.before(this.picker);
        this.native.classList.add('psl-native-options-hidden');
        this.refreshOptions();
      }
      addOption(group,value,text){
        const label=document.createElement('label');const input=document.createElement('input');const span=document.createElement('span');
        input.type='radio';input.name='psl-'+group+'-'+this.sectionId;input.value=value;
        if(group==='colours'){
          const dot=document.createElement('i');dot.className='psl-colour-dot';dot.setAttribute('aria-hidden','true');dot.style.setProperty('--swatch',{black:'#202325',white:'#ffffff',beige:'#c5b99e'}[value]);span.append(dot);
        }
        span.append(document.createTextNode(text));label.append(input,span);this.picker.querySelector('[data-'+group+'] .psl-option-buttons').append(label);
        input.addEventListener('change',()=>{
          if(group==='colours')this.colour=value;else this.size=value;
          let item=this.map.find(x=>x.colour===this.colour&&x.size===this.size&&x.variant.available);
          if(!item){this.size=null;this.confirmed=false;item=this.map.find(x=>x.colour===this.colour&&x.variant.available);}else{
            this.confirmed=true;
          }
          if(item){
            this.refreshNative();
            if(!this.native)return;
            const radios=[...this.native.querySelectorAll('input[type=radio],select option')];
            let radio=item.optionValueId?radios.find(r=>String(r.dataset.optionValueId)===item.optionValueId):null;
            if(!radio)radio=radios.find(r=>r.value===item.variant.options[0]);
            if(!radio&&this.hasColours)radio=radios.find(r=>{
              const choice=this.parseCombined(r.value);
              return choice?.size===item.size&&choice?.colour===item.colour;
            });
            if(!radio)return;
            if(radio.tagName==='OPTION'){
              const select=radio.closest('select');
              select.value=radio.value;select.dispatchEvent(new Event('change',{bubbles:true}));
            }else{
              radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));
            }
          }
          this.refreshOptions();this.sync();
        },{signal:this.abort.signal});
      }
      refreshOptions(){
        this.picker.querySelectorAll('[data-colours] input').forEach(r=>{r.checked=r.value===this.colour;r.disabled=!this.map.some(x=>x.colour===r.value&&x.variant.available);});
        this.picker.querySelectorAll('[data-sizes] input').forEach(r=>{r.checked=r.value===this.size;r.disabled=!this.map.some(x=>x.colour===this.colour&&x.size===r.value&&x.variant.available);});
        if(this.confirmed)this.picker.querySelector('.psl-choice-message').textContent='';
      }
      requestSize(){
        if(!this.picker)return;
        this.picker.querySelector('.psl-choice-message').textContent=this.dataset.choose;
        const target=this.picker.querySelector('[data-sizes] input:not(:disabled)');
        this.picker.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'center'});
        target?.focus({preventScroll:true});
      }
      sync(){
        const label=this.mainButton.querySelector(':scope > span');
        if(!this.confirmed&&label&&label.textContent.trim()!==this.dataset.choose)label.textContent=this.dataset.choose;
        const busy=this.mainButton.getAttribute('aria-disabled')==='true';
        const text=busy?this.dataset.adding:!this.confirmed?this.dataset.choose:label?.textContent.trim()||'';
        if(this.barButton.textContent!==text)this.barButton.textContent=text;
        this.barButton.disabled=this.mainButton.disabled||busy;
        const regular=this.priceRoot?.querySelector('.price__regular .price-item--regular');
        const sale=this.priceRoot?.querySelector('.price__sale .price-item--sale');
        const price=this.priceRoot?.querySelector('.price--on-sale')?sale:regular;
        if(price)this.bar.querySelector('[data-sticky-price]').textContent=price.textContent.trim();
        const variantTitle=this.bar.querySelector('[data-sticky-variant]');
        if(this.picker){
          const checked=this.picker.querySelector('[data-sizes] input:checked');
          variantTitle.textContent=this.confirmed?(this.hasColours?this.colourLabels[this.colour]+' · ':'')+checked?.nextElementSibling.textContent:this.dataset.choose;
        }else{
          const native=this.info.querySelector('variant-selects');
          const selected=native?[...native.querySelectorAll('input:checked,select')].map(x=>x.value).join(' / '):'';
          variantTitle.textContent=selected;
        }
      }
      disconnectedCallback(){
        this.abort?.abort();this.abort=null;this.variantUnsubscribe?.();this.nativeObserver?.disconnect();
        this.observer?.disconnect();this.buttonObserver?.disconnect();this.priceObserver?.disconnect();
        this.native?.classList.remove('psl-native-options-hidden');this.picker?.remove();this.singleSize?.remove();
        this.picker=null;this.singleSize=null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["psl-product-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('psl-product-navigation')) {
    customElements.define('psl-product-navigation', class extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        const button = document.getElementById('ProductSubmitButton-' + this.dataset.sectionId);
        if (!button || !this.link) return;
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          this.link.hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
        });
        this.observer.observe(button);
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
